// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var DashboardEmailsController = function ($scope, $rootScope, $location, $routeParams, $http, $interval, Email) {
    var load = function () {
        var emailsAfterDate = new Date(new Date().getTime() - 432000000).toISOString(); //432000000 ms = 5 days, getting Emails from the last 5 days
        $scope.emails = $scope.paginator(function (options, callback) {
            return Email.query(options, function () { callback(); $scope.wasSearching = options.search; });
        }, { search: null, statusFilter: 'ToBeSent|Sent', after: emailsAfterDate }, 20);
    }

    $scope.$on('refresh', function(event) {
         load();
    });
    load();
};
DashboardEmailsController.$inject = ['$scope', '$rootScope', '$location', '$routeParams', '$http', '$interval', 'Email'];
